import styled from 'styled-components'
import * as _ from 'styles/helpers'
import type { Props } from './ChatWindow'

const StyledChatWindow = styled.div<Partial<Props>>`
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: ${_.rem(16)} ${_.rem(24)} 0;
	height: 100%;
	overflow: hidden;

	> div {
		display: flex;
		flex-direction: column;
		flex: 1;
		height: 100%;
		min-height: 0;
	}
`

export default StyledChatWindow
